<template>
  <div>
    <div v-if="currentMenuHijo == 'C' + category.categoria_padre_id">
        <b-list-group-item @click="currentMenuHijo = mapMenu[mapMenu.length -2]" v-if="indice == 0"
            href="#"
            class="d-flex justify-content-between align-items-center text-white">
            <div>
                <h5> 
                    <b-icon icon="caret-left-fill" class="mr-2"></b-icon>
                    Volver
                </h5>
            </div>
        </b-list-group-item>
        <b-list-group-item :to="{name: 'inventoryEmpresaList', params:{ id: category.id, category: category.nombre}}"
            class="d-flex justify-content-between align-items-center text-white">
            <div>
                <h5>
                {{category.nombre}}
                </h5>
            </div>
            <b-icon icon="caret-right-fill" style="cursor: pointer"  
            @click="currentMenuHijo = 'C' + category.id" v-if="category.sub_categories.length"></b-icon>
        </b-list-group-item>
    </div>
    <showCategories v-for="(category, index) in category.sub_categories" :key="index" :indice="index" :mapMenu="mapMenu" :category="category" v-model="currentMenuHijo"/>
  </div>
</template>

<script>
export default {
  name: "showCategories",
  props: ["category", "value", "indice", "mapMenu"],
  computed: {
    currentMenuHijo: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    mostrar(){
      
    }
  }
};
</script>

<style scoped>
.list-group-item {
    background-color: #343a40;
}

.list-group-item:hover {
    background-color: #535e69;
}

.list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
    background-color: #535e69 !important;
}
</style>